import React from "react";

import { Divider, FormGroup, NonIdealState } from "@blueprintjs/core";
import TextWidget from "common/form/widgets/TextWidget";
import * as configActions from "core/actions/configActions";
import initialState from "core/reducers/initialState";
import Class from "core/util/Class";
import { generateSchema } from "decorator-form";
import Form from "react-jsonschema-form";
import { connect } from "react-redux";
import { Registry } from "react-registry";
import { bindActionCreators, Dispatch } from "redux";

/**
 * connected component that finds a view's config class
 * and renders a form to edit the value for a variant.
 *
 * @author chris
 */

interface IViewConfigOwnProps {
	id: string;
	instance: string;
}

interface IViewConfigStateProps<T = any> {
	config: T;
	schema: null | ReturnType<typeof generateSchema>;
}

interface IViewConfigDispatchProps {
	actions: typeof configActions;
}

type ResultProps<T = any> = IViewConfigStateProps<T> & IViewConfigDispatchProps & IViewConfigOwnProps;

function mapStateToProps(state: typeof initialState = initialState, ownProps: IViewConfigOwnProps): IViewConfigStateProps {

	const clazz = Registry.get({id: ownProps.id, registry: "views:config"}) as Class<any>;

	const config = (
		state.config.views[ownProps.id] && state.config.views[ownProps.id][ownProps.instance]
		|| (clazz && new clazz())
		|| {}
	);

	return {
		config,
		schema: clazz ? generateSchema(clazz) : null
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IViewConfigDispatchProps {

	return {
		actions: bindActionCreators(configActions, dispatch)
	};
}

function ViewConfigForm<T = any>(props: ResultProps<T>) {

	if (!props.schema) {
		return (
			<NonIdealState title="No Config Found" />
		);
	}

	const keyPrefix = props.id + ":" + props.instance;

	return (
		<div>
			<FormGroup label="Variant Name" key={keyPrefix + ":editname"}>
				<TextWidget
					onChange={(value: string) => props.actions.configViewAdd(props.id, props.instance, {...props.config || {}, __editName: value })}
					value={props.config && (props.config as any).__editName || ''}
				/>
			</FormGroup>
			<Divider />
			<Form
				key={keyPrefix + ":config"}
				{...props.schema}
				formData={props.config}
				onChange={
					(form: any) => props.actions.configViewAdd(props.id, props.instance, form.formData)
				}
			><div /></Form>
		</div>
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewConfigForm);



// WEBPACK FOOTER //
// ./src/core/components/editor/views/ViewConfigForm.tsx